import React from 'react'
import Jumbotron from '../../Component/Jumbotron'
import About from '../../Component/About'
import CardLinks from '../../Component/CardLinks'
import Separator from '../../Component/Separator'
import Exp from '../../Component/Exp'
import Education from '../../Component/Education'
import Social from '../../Component/Social'
import Contato from '../../Component/Contato'

export default function Home() {

    return (
        <>
            <Jumbotron height={80} message={true}/>
            <About />
            <CardLinks />
            <Separator oldColor={'#f0f2f5'} nextColor={'#010008'} jumbo={false} />
            <Exp />
            <Separator oldColor={'#010008'} nextColor={'#f0f2f5'} jumbo={false} />
            <Education />
            <Separator oldColor={'#f0f2f5'} nextColor={'#010008'} jumbo={false} />
            <Social />
            <Separator oldColor={'#010008'} nextColor={'#f0f2f5'} jumbo={false} />
            <Contato />
        </>
    )
}